import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import InputField from "./InputField";
import AuthService from "../services/AuthService";
import DealerShipDetails from "../services/DealerShipInfo";
import "react-toastify/dist/ReactToastify.css";
import "../styles/SignUpCard.css";
import Swal from "sweetalert2";

const SignUpCard = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState(""); // New state for password
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState(""); // New state for password error
  const navigate = useNavigate();
  const [showDetails, setShowDetails] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // State for button disabling
  const [staticUserData,setStaticUserData]=useState({})
  const [validationResponse, setValidationResponse]=useState({});
  /*const staticUserData = {
    "123456": {
      massName: "Example Mass 1",
      massAddress: "123 Main St, Anytown",
      massGst: "GST1234567890",
      massPan: "ABCD",
      massRegion: "North",
      ceoName: "John Doe",
      ceoEmail: "john.doe@example.com",
      ceoPhone: "9876543210",
    },
    "789012": {
      massName: "Another Mass Corp",
      massAddress: "456 Oak Ave, Somecity",
      massGst: "GSTR9876543210",
      massPan: "EFGH",
      massRegion: "South",
      ceoName: "Jane Smith",
      ceoEmail: "jane.smith@another.com",
      ceoPhone: "1234567890",
    },
    // Add more static user data as needed
  };*/

// Helper function to mask PAN except last 4 digits
const maskPan = (pan) => {
  if (!pan) return "";
  const visibleDigits = 4;
  const maskedLength = Math.max(pan.length - visibleDigits, 0);
  const maskedPart = "*".repeat(maskedLength);
  const visiblePart = pan.slice(-visibleDigits);
  return maskedPart + visiblePart;
};

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true); // Disable the button on submit

    // Reset previous errors
    setUsernameError("");
    setPasswordError(""); // Clear password error

    let hasError = false;

    // Custom validation for empty MSPIN
    if (!username.trim()) {
      setUsernameError("Please enter the MSPIN.");
      hasError = true;
    }

    // Custom validation for empty password
    if (!password.trim()) { // New password validation
      setPasswordError("Please enter a password.");
      hasError = true;
    }

    if (hasError) {
      setIsSubmitting(false); // Re-enable button if there are validation errors
      return;
    }

    // Simulate an asynchronous operation (like an API call)
    //await new Promise(resolve => setTimeout(resolve, 1000)); // Optional delay for visual feedback
    try{

      const response =await AuthService.signUp(username, password);
      console.log("response from validation"+JSON.stringify(response));
      setValidationResponse(response);
      setShowDetails(true)
    // Static data check and show details
   // if (staticUserData.hasOwnProperty(username)) {
      //setShowDetails(true);
      // Do NOT clear the input field on correct input here.
      // Clearing happens only when the modal is closed.
    //} else {
    }catch (error) {
      Swal.fire({
        title: "Error",
        text: "Invalid Sign Up credentials. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setShowDetails(false);
      setUsername(""); // Clear the input field on incorrect input
      setPassword(""); // Clear password on incorrect input
    }

    setIsSubmitting(false); // Re-enable the button after the operation
  };

  const handleCloseDetails = async() => {
    setShowDetails(false);
    try{

      const {creationMessage} = await DealerShipDetails.saveDealerInfo(validationResponse);

    Swal.fire({
      title: "Success!",
      text: "Dealer Onboarding Details Saved Successfully.",
      icon: "success",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    }).then(() => {
      navigate("/login"); // Navigate only after alert closes
    });
    }
    catch (error) {
    console.error("Error saving dealer details:", error);

    // Get error message from error object
    const errorMessage = error.message || "Dealer Details Not Saved. Please try again.";
    
    // Check if it's an onboarding status error
    if (errorMessage.includes("already pending") || errorMessage.includes("wait for approval")) {
      Swal.fire({
        title: "Onboarding Request Already Submitted",
        text: "Your onboarding request is already pending. Please wait for approval.",
        icon: "info",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    } else if (errorMessage.includes("already onboarded") || errorMessage.includes("Cannot request onboarding again")) {
      Swal.fire({
        title: "Already Onboarded",
        text: "You are already onboarded. Cannot request onboarding again.",
        icon: "info",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        navigate("/login"); // Navigate to login if already onboarded
      });
    } else {
      Swal.fire({
        title: "Error!",
        text: errorMessage,
        icon: "error",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });
    }
  }
    // Clearing the username is now handled in the handleSubmit for incorrect input
    // and when the modal is closed (if you still want that behavior).
    // If you only want to clear on incorrect input, you can remove setUsername(""); here.
  };

  return (
    <div className="sign-up-card">
      <div className="already-account" style={{ textAlign: "center" }}>
        Already have an account?{" "}
        <button
          className="login-link"
          onClick={() => navigate("/login")}
          style={{
            backgroundColor: "transparent",
            color: "#007bff",
            border: "none",
            fontWeight: "bold",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          Login
        </button>
      </div>

      <form onSubmit={handleSubmit} className="w-100">
        <InputField
          label="MSPIN"
          type="text"
          value={username}
          onChange={(e) =>
            e.target.value.length <= 50 && setUsername(e.target.value)
          }
          placeholder="Enter MSPIN"
          errorMessage={usernameError}
          maxLength={50}
        />

        <InputField
          label="Password" // Label for the new password field
          type="password"
          value={password}
          onChange={(e) =>
            e.target.value.length <= 50 && setPassword(e.target.value)
          }          placeholder="Enter password"
          errorMessage={passwordError} // Display password error
          maxLength={50}
        />

        <button
          type="submit"
          className="btn btn-primary sign-up-button"
          disabled={isSubmitting} // Disable the button based on isSubmitting state
        >
          {isSubmitting ? "Verifying..." : "Verify"} {/* Show loading text */}
        </button>
      </form>

      {showDetails  && (
        <div className="modal-overlay">
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2 style={{ marginBottom: "20px" }}>Mass Details</h2>
            <p>
              <strong>Mass Name:</strong> {validationResponse.userAuthenticationSuccessResponse.DealerName}
            </p>
            <p>
              <strong>Mass Address:</strong> {validationResponse.DealerAddress}
            </p>
            <p>
              <strong>Mass GST Number:</strong> {validationResponse.DealerGstNumber}
            </p>
            <p>
              <strong>Mass Pan (Last 4 Digits):</strong>{" "}
              {maskPan(validationResponse.DealerPanNumber)}
            </p>
            <p>
              <strong>Mass Region:</strong> {validationResponse.userAuthenticationSuccessResponse.RegionDesc}
            </p>
            <p>
              <strong>CEO Name:</strong> {validationResponse.CeoName}
            </p>
            <p>
              <strong>CEO Email:</strong> {validationResponse.CeoEmailId}
            </p>
            <p>
              <strong>CEO Phone Number:</strong> {validationResponse.CeoPhone}
            </p>
            <button
              onClick={handleCloseDetails}
              style={{
                backgroundColor: "#1f4c9a",
                color: "white",
                border: "none",
                padding: "12px 28px",
                borderRadius: "10px",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >
              Submit
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignUpCard;